import { lazy } from 'react'

const UserList = lazy(() => import('@/pages/User/List'))
const UserForm = lazy(() => import('@/pages/User/Form'))

const userRoute = {
  path: 'user',
  meta: { title: '用户管理', icon: 'UserOutlined', permission: 'user:view' },
  children: [
    {
      path: 'list',
      element: <UserList />,
      meta: { title: '用户列表', permission: 'user:list' },
    },
    {
      path: 'add',
      element: <UserForm />,
      meta: { title: '添加用户', permission: 'user:add' },
    },
    {
      path: 'edit/:id',
      element: <UserForm />,
      meta: { title: '编辑用户', permission: 'user:edit' },
    },
  ],
}

export default userRoute
